import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-601875ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = { class: "wrapper_container" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "angelleague_info" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angelleague_img",
    src: "/assets/image/angelleague_logo.png"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "angelleague_title" }, " 엔젤리그 ")
], -1))
const _hoisted_8 = { class: "wrapper_container" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "content_box" }
const _hoisted_12 = { class: "question" }
const _hoisted_13 = {
  key: 0,
  class: "indicator",
  src: "/assets/icon/slide_down_gray@3x.png"
}
const _hoisted_14 = {
  key: 1,
  class: "indicator",
  src: "/assets/icon/slide_up_gray@3x.png"
}
const _hoisted_15 = { class: "answer" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "wrapper_container" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "angelleague_info" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angelleague_img",
    src: "/assets/image/angelleague_logo.png"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "angelleague_title" }, " 엔젤리그 조합 생성 과정 ")
], -1))
const _hoisted_20 = { class: "index_box" }
const _hoisted_21 = { class: "index_text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "index_bg" }, null, -1))
const _hoisted_23 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_angel_league_info = _resolveComponent("angel-league-info")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("span", null, "엔젤리그 소개", 512), [
            [_vShow, _ctx.typeValue == 'info']
          ]),
          _withDirectives(_createElementVNode("span", null, "자주 묻는 질문", 512), [
            [_vShow, _ctx.typeValue == 'FAQ']
          ]),
          _withDirectives(_createElementVNode("span", null, "조합 생성 과정", 512), [
            [_vShow, _ctx.typeValue == 'process']
          ]),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "닫기")
        ])
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_angel_league_info)
          ])
        ], 512), [
          [_vShow, _ctx.typeValue == 'info']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FAQData, (value, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "drawer_content"
              }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.showToggle(idx))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.FAQData[idx].title), 1),
                    (!_ctx.questionArr[idx])
                      ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                      : (_openBlock(), _createElementBlock("img", _hoisted_14))
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.FAQData[idx].content
                    }, null, 8, _hoisted_16)
                  ], 512), [
                    [_vShow, _ctx.questionArr[idx]]
                  ])
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.typeValue == 'FAQ']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ProcessData, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "process_container"
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(v.index), 1),
                  _hoisted_22
                ]),
                _createElementVNode("div", {
                  class: "info_content",
                  innerHTML: v.content
                }, null, 8, _hoisted_23)
              ]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.typeValue == 'process']
        ])
      ]),
      _: 1
    })
  ], 64))
}